import { render, staticRenderFns } from "./EmployeeDetailModal.vue?vue&type=template&id=ed0d2eb0&scoped=true&"
import script from "./EmployeeDetailModal.vue?vue&type=script&lang=js&"
export * from "./EmployeeDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeDetailModal.vue?vue&type=style&index=0&id=ed0d2eb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0d2eb0",
  null
  
)

export default component.exports